import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=9fa57e5a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa57e5a')) {
      api.createRecord('9fa57e5a', component.options)
    } else {
      api.reload('9fa57e5a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=9fa57e5a&", function () {
      api.rerender('9fa57e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25sdy7AQ8rsNt/JS/comp/IncreaseNumber.vue"
export default component.exports